import axios from 'axios';

export default (trackingEvent) => axios.post(`${process.env.VUE_APP_API_ENDPOINT}/tracking`, trackingEvent);
